"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenOtrDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const common_1 = require("./common");
/**
 * Token OTR Dataset
 */
class TokenOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Sell base token via OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link TradeTokenTangleRequest}
         * @returns
         */
        this.sellBaseToken = (params) => {
            delete params.symbol;
            return new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SELL_TOKEN }), Math.floor((params.count || 0) * (params.price || 0)));
        };
        /**
         * Sell minted token
         *
         * @param params Use {@link OtrRequest} with data based on {@link TradeTokenTangleRequest}
         * @returns
         */
        this.sellMintedToken = (tokenId, params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SELL_TOKEN }), undefined, { amount: BigInt(params.count || 0), id: tokenId });
        /**
         * Buy token.
         *
         * @param params Use {@link OtrRequest} with data based on {@link TradeTokenTangleRequest}
         * @returns
         */
        this.buyToken = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.BUY_TOKEN }), Math.floor((params.count || 0) * (params.price || 0)));
        /**
         * Stake token
         *
         * @param params Use {@link OtrRequest} with data based on {@link TokenStakeTangleRequest}
         * @returns
         */
        this.stake = (tokenId, count, params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.STAKE }, params), undefined, { amount: BigInt(count), id: tokenId });
        /**
         * Claim airdrop
         *
         * @param params Use {@link OtrRequest} with data based on {@link ClaimAirdroppedTokensTangleRequest}
         * @returns
         */
        this.claimAirdrops = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.CLAIM_MINTED_AIRDROPS }));
    }
}
exports.TokenOtrDataset = TokenOtrDataset;
